import "../../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Modal, Box } from "@mui/material";
import FormDetalle from './formDetalle/formDetalle';
import DetalleFiltersModal from './gridDetalle/detalleFiltersModal';
import { ListasDetFormState } from '../../../../context/listasdet/ListasDetFormState';
import { ListasDetContext } from '../../../../context/listasdet/ListasDetContext';
import { ArticulosState } from '../../../../context/articulos/ArticulosState';
import { formatRows } from "./configGrid/rows";
import { indice } from "../../../../components/DataGrid/indice";
import { getActionColumn } from "../../../../components/DataGrid/actionColumns";
import useDocumentTitle from "../../../../components/Title";
import CustomDataGrid from "../../../../components/DataGrid/CustomDataGrid";
import ConfirmDialog from "../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { Paginator } from '../../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import CircularProgress from "@mui/material/CircularProgress";

export const DatatableDetalle = ({
  lpid,              // ID de la lista de precios (cabecera)
  tipoprecio,        // 0 = Mayorista, 1 = Minorista, 2 = Costo 
  arrayDetalle,      // Array temporal de items
  addItem,
  getItem,
  updateItem,
  removeItem,
  clearArray,
  isCabComplete,
  setIsDetalleFilled
}) => {
  const contexto = useContext(ListasDetContext);
  const { deleteListaDetData, getListaDetPanelData, getListaDetByIdData } = contexto;

  // Modales
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);
  const [isModalArrayDetalleOpen, setIsModalArrayDetalleOpen] = useState(false);

  // Estado para Datos y Paginación
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);

  // Paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);

  // Buscador
  const [searchArtId, setSearchArtId] = useState();
  const [searchArtDesc, setSearchArtDesc] = useState();

  // Refs
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);

  // Modal de confirmación para eliminar
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Manejo de errores
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const nameData = "Artículo";
  const getData = getListaDetPanelData;
  const deleteData = deleteListaDetData;

  // Efecto para cargar datos
  useEffect(() => {
    fetchData();
  }, [lpid, searchArtId, numPagina, filas, JSON.stringify(arrayDetalle)]);

  // Limpiar array si cambia tipoPrecio
  useEffect(() => {
    if (arrayDetalle.length > 0) {
      clearArray();
    }
  }, [tipoprecio]);

  // Actualizar estado de detalle lleno
  useEffect(() => {
    setIsDetalleFilled(totalItems > 0 || arrayDetalle.length > 0);
  }, [totalItems, arrayDetalle.length]);
  

const fetchData = async () => {
  if (isFetchingRef.current) return;

  isFetchingRef.current = true;
  setIsLoading(true);

  try {
    const result = await fetchEntityData(
      getData,
      searchArtId,
      numPagina,
      filas,
      lpid,
      setListaItems,
      setTotalItems,
      arrayDetalle
    );

    
  } catch (error) {
    console.error("ERROR fetchData:", error);
  } finally {
    
    setIsLoading(false);
    isFetchingRef.current = false;
  }
};

  // Editar artículo
  const handleClickEdit = async (id) => {
    try {
      // Buscar el art_id real del item
      const item = listaItems.find(i => i.id === id || i.art_id === id);
      setSelectedItem(item?.art_id || id);
      handleOpenDetalleModal();
    } catch (error) {
      console.error("Error al obtener detalles:", error);
    }
  };

  // Eliminar artículo
  const handleDelete = async () => {
    try {
      await deleteItem(
        deleteData,
        selectedItem,
        lpid,
        arrayDetalle,
        removeItem,
        getListaDetByIdData
      );
      await fetchData();
      closeModal();
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage("");
    setIsErrorDialogOpen(false);
  };

  const openModal = (id) => {
    // Buscar art_id real
    const item = listaItems.find(i => i.id === id || i.art_id === id);
    setSelectedItem(item?.art_id || id);
    setIsModalOpen(true);
  };

  const closeModal = async () => {
    await fetchData();
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleOpenDetalleModal = () => {
    setIsModalDetalleOpen(true);
  };

  const handleCloseDetalleModal = async () => {
    await fetchData();
    setIsModalDetalleOpen(false);
    setSelectedItem(null);
  };

  const handleArrayDetalleOpenModal = () => {
    setIsModalArrayDetalleOpen(true);
  };

  const handleArrayDetalleCloseModal = async () => {
    await fetchData();
    setIsModalArrayDetalleOpen(false);
  };

  // Headers según tipoprecio
  const headers = getHeaders(tipoprecio);

  // Columnas para el DataGrid
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas)
    .concat(headers.filter((column) => !column.hidden))
    .concat(getActionColumn(handleClickEdit, openModal));
    return commonCols 
  }, [numPagina, filas, tipoprecio]);
  
 
  
  const rows = useMemo(() => {
  const result = formatRows(listaItems, tipoprecio);
  return result;
}, [listaItems, tipoprecio]);

  return (
    <>
      <div className="datatable">
        <div className="datatableTitle">
          Artículos de la Lista de Precios

          {lpid && (
            <FiltersGrid
              setSearchIDFilter={setSearchArtId}
              setSearchDescFilter={setSearchArtDesc}
            />
          )}

          <button
            type="button"
            className={`link ${!isCabComplete ? "disabled" : "enabled"}`}
            onClick={handleOpenDetalleModal}
            disabled={!isCabComplete}
          >
            Agregar
          </button>

          <button
            type="button"
            className={`link ${!isCabComplete ? "disabled" : "enabled"}`}
            onClick={handleArrayDetalleOpenModal}
            disabled={!isCabComplete}
          >
            Agregar con filtros
          </button>
        </div>
 
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onPageChange={(newPage) => setNumPagina(newPage)}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
              enablePagination={false}
            />

          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}  // Total de páginas
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />
          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          /> 
      </div>

      {/* Modal: Agregar con filtros (múltiples artículos) */}
      <ListasDetFormState>
        <Modal
          open={isModalArrayDetalleOpen}
          onClose={handleArrayDetalleCloseModal}
          aria-labelledby="modal-form-detalle-filtros"
          className="modalLista"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%',
              maxHeight: '80%',
              width: '100%',
              height: 'auto',
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto',
            }}
          >
            <ArticulosState>
              <DetalleFiltersModal
                tipoprecio={tipoprecio}
                addItem={addItem}
                closeModal={handleArrayDetalleCloseModal}
              />
            </ArticulosState>
          </Box>
        </Modal>
      </ListasDetFormState>

      {/* Modal: Agregar/Editar un artículo */}
      <ListasDetFormState>
        <Modal
          open={isModalDetalleOpen}
          onClose={handleCloseDetalleModal}
          aria-labelledby="modal-form-detalle"
          className="modalLista"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%',
              maxHeight: '80%',
              width: '100%',
              height: 'auto',
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto',
            }}
          >
            <FormDetalle
              iddet={selectedItem}
              lpid={lpid}
              tipoprecio={tipoprecio}
              arrayDetalle={arrayDetalle}
              addItem={addItem}
              updateItem={updateItem}
              getItem={getItem}
              removeItem={removeItem}
              closeModal={handleCloseDetalleModal}
              totalItems={totalItems}
            />
          </Box>
        </Modal>
      </ListasDetFormState>
    </>
  );
};

export default DatatableDetalle;
